<template>
  <v-container>Cargando sesión...</v-container>
</template>

<script>
import { useGameStore } from "@/stores/game";

export default {
  async mounted() {
    try {
      const token = this.$route.query.token;
      const rawUser = this.$route.query.user;
      const user = rawUser ? JSON.parse(decodeURIComponent(rawUser)) : null;

      if (!token || !user) {
        this.$router.push('/login?error=auth_failed');
        return;
      }

      const store = useGameStore();
      store.setAuth(token, user);
      await store.loadAll();
      this.$router.push('/');
    } catch (e) {
      this.$router.push('/login?error=auth_failed');
    }
  }
}
</script>